<template>
  <!-- Panel filtrów do widoku archiwalnych pomiarów pojazdów -->
  <div class="filters-container">
    <!-- Komponent legendy (wyjaśnienie ikon/statusów) — tylko w kroku 1 (wybór lokalizacji) -->
    <legend-list v-if="archival.step === 1" />
    
    <!-- Filtr lokalizacji (np. wybór stacji preselekcji lub punktu pomiarowego) -->
    <locations-filter-view :store="filtersStore" />

    <!-- Filtr zakresu dat (wybór przedziału czasu dla archiwalnych danych) -->
    <date-range-filter-view :store="filtersStore" />

    <!-- Filtr numerów pasów ruchu (np. pas 1, 2, 3...) -->
    <lane-numbers-filter-view :store="filtersStore" />

    <!-- Filtr kategorii pojazdów (np. ciężarowe, dostawcze, osobowe) -->
    <vehicle-categories-filter-view
        v-if="!isSG"
        :store="filtersStore"
    />

    <!-- Filtr naruszeń (np. przekroczenie masy, prędkości, inne wykroczenia) -->
    <violation-filter-view :store="filtersStore" />

    <!-- Filtr dodatkowych danych pojazdu (np. masa, długość, liczba osi itp.) -->
    <vehicle-data-filter-view />
  </div>
</template>

<script>
// Import Pinia store do zarządzania filtrami archiwum
import { useArchivalFiltersStore } from "@/stores/archivalFilters";
// Store z aktualnym krokiem kreatora (do warunkowego pokazania legendy)
import { useArchivalStore } from "@/stores/archival";
// Import komponentów – każdy filtr jest osobnym komponentem
import LocationsFilterView from "./filters/LocationsFilterView.vue";
import DateRangeFilterView from "./filters/DateRangeFilterView.vue";
import LaneNumbersFilterView from "./filters/LaneNumbersFilterView.vue";
import VehicleCategoriesFilterView from "./filters/VehicleCategoriesFilterView.vue";
import ViolationFilterView from "./filters/ViolationFilterView.vue";
import VehicleDataFilterView from "./archival/VehicleDataFilterView.vue";
import LegendList from "./filters/LegendList.vue";
import { isSG } from "@/config/appVersion";

export default {
  // Nazwa komponentu – może być używana do debugowania i w parentach
  name: "FilterArchivalMeasurements",

  // Rejestracja komponentów używanych w template
  components: {
    LocationsFilterView,
    DateRangeFilterView,
    VehicleCategoriesFilterView,
    ViolationFilterView,
    VehicleDataFilterView,
    LaneNumbersFilterView,
    LegendList,
  },

  // Composition API – setup
  setup() {
    // Pobranie Pinia store z filtrami dla archiwum
    const filtersStore = useArchivalFiltersStore();
    // Store z bieżącym krokiem (legendę pokazujemy tylko w kroku 1)
    const archival = useArchivalStore();
    // Udostępniamy je w template
    return { filtersStore, archival, isSG };
  },
};
</script>

<style scoped>
/* Styl panelu filtrów: szerokość i tło (dopasowane do reszty widoku) */
.filters-container {
  background: var(--surface-secondary);
}
</style>
